import { Button, Field, Input } from "@cvpartner/design-system";
import * as React from "react";
import { I18n } from "@/util/translations";
import { Form } from "./shared/Form";
import { LoginButtonWrapper, Wrapper } from "./shared/Modern";
import { CardContent } from "./shared/modern/LoginCard";

export const OtpLogin: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <Wrapper
      heading={I18n.t("signin.header_title")}
      subheading={I18n.t("signin.header_subtitle")}
    >
      <Form
        action="/login/otp"
        onSubmit={() => {
          setIsLoading(true);
        }}
      >
        <CardContent>
          <div>
            <Field name="otp_code" label={I18n.t("signin.otp_label")}>
              <Input
                placeholder="123456"
                type="number"
                required={true}
                autoFocus={true}
              />
            </Field>
          </div>
          <LoginButtonWrapper center={isLoading}>
            {isLoading ? (
              <Button
                type="submit"
                hierarchy="primary"
                variant="iconOnly"
                loading={true}
              />
            ) : (
              <Button type="submit" hierarchy="primary">
                {I18n.t("signin.continue_button")}
              </Button>
            )}
          </LoginButtonWrapper>
        </CardContent>
      </Form>
    </Wrapper>
  );
};
